import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

/**
 * Order-confirmation button. The address stays the same; the destination follows the account.
 */
const SignupContinuePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = (searchParams.get('t') || '').trim();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!token) {
      setError(true);
      return;
    }

    let cancelled = false;
    const go = async () => {
      try {
        const resolveTarget = httpsCallable(functions, 'getSignupContinueTarget');
        const result = await resolveTarget({ token });
        const data = result.data as { valid?: boolean; path?: string };
        if (cancelled) return;
        if (!data.valid || !data.path || !data.path.startsWith('/')) {
          setError(true);
          return;
        }
        navigate(data.path, { replace: true });
      } catch {
        if (!cancelled) setError(true);
      }
    };
    void go();
    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-dark-950 px-4">
        <p className="text-center text-gray-300">
          This link is not valid. Open the order email again, or sign in from the home page.
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-dark-950">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-emerald-500 border-t-transparent" />
    </div>
  );
};

export default SignupContinuePage;
